import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheckDollar, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';

import * as S from './styles';
import { Band, Inner, SectionHead } from '../ui/Section';
import Reveal from '../ui/Reveal';
import { HandIcon, PolishIcon } from '../ui/NailIcons';

const bold = { b: (chunks) => <b>{chunks}</b> };
const span = { span: (chunks) => <span>{chunks}</span> };

const RULES = [
  { id: 'schedulingPolicy.deposit', icon: <FontAwesomeIcon icon={faMoneyCheckDollar} size="lg" /> },
  { id: 'schedulingPolicy.refund', icon: <FontAwesomeIcon icon={faTriangleExclamation} size="lg" /> },
  { id: 'schedulingPolicy.late', icon: <FontAwesomeIcon icon={faClock} size="lg" /> },
  { id: 'schedulingPolicy.duration', icon: <HandIcon size={30} /> },
  { id: 'schedulingPolicy.noPolish', icon: <PolishIcon size={26} /> },
];

function SchedulingPolicy() {
  return (
    <Band id="politica" $tone="dark">
      <Inner>
        <SectionHead tone="dark" eyebrow={<FormattedMessage id="policy.eyebrow" />}>
          <FormattedMessage id="schedulingPolicy.title" values={span} />
        </SectionHead>

        <S.Rules>
          {RULES.map((rule, i) => (
            <Reveal key={rule.id} as="li" delay={i * 70}>
              <span className="icon">{rule.icon}</span>
              <p>
                <FormattedMessage id={rule.id} values={bold} />
              </p>
            </Reveal>
          ))}
        </S.Rules>
      </Inner>
    </Band>
  );
}

export default SchedulingPolicy;
